<div class="mt-5" *ngIf="validatingToken">
    <div class="col-12 text-center"><h1>Checking reset password Link...</h1></div>
</div>
<div class="mt-3" *ngIf="!validatingToken && !isValid">
    <h1>Your login link has expired.</h1>
    <a [href]="failUrl" class="btn btn-primary">Back To Reporting</a>
</div>
<div class="mt-5" *ngIf="!validatingToken && isValid">
    <div class="col-12 text-center"><h1>Link is valid. Redirecting To User's Dashboard...</h1></div>
</div>